import { render, staticRenderFns } from "./govWeb.vue?vue&type=template&id=2db22164&scoped=true"
import script from "./govWeb.vue?vue&type=script&lang=js"
export * from "./govWeb.vue?vue&type=script&lang=js"
import style0 from "./govWeb.vue?vue&type=style&index=0&id=2db22164&prod&lang=scss"
import style1 from "./govWeb.vue?vue&type=style&index=1&id=2db22164&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db22164",
  null
  
)

export default component.exports